import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { HomePage } from "./pages/HomePage";
import { ProyectoPage } from "./pages/ProyectoPage";
import { EquipoPage } from "./pages/EquipoPage";
import { ProgramasPage } from "./pages/ProgramasPage";
import { ProgramaDetallePage } from "./pages/ProgramaDetallePage";
import { EdicionDetallePage } from "./pages/EdicionDetallePage";
import { ContactoPage } from "./pages/ContactoPage";
import { GaleriasPage } from "./pages/GaleriasPage";
import { GaleriaDetallePage } from "./pages/GaleriaDetallePage";
import { NoticiasPage } from "./pages/NoticiasPage";
import { NoticiaDetallePage } from "./pages/NoticiaDetallePage";
import { EventosPage } from "./pages/EventosPage";
import { EventoDetallePage } from "./pages/EventoDetallePage";
import { AccesibilidadPage } from "./pages/AccesibilidadPage";
import { PaginaEstaticaPage } from "./pages/PaginaEstaticaPage";
import { NotFoundPage } from "./pages/NotFoundPage";

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="/proyecto" element={<ProyectoPage />} />
        <Route path="/proyecto/equipo" element={<EquipoPage />} />
        <Route path="/programas" element={<ProgramasPage />} />
        <Route path="/programas/:slug" element={<ProgramaDetallePage />} />
        <Route path="/programas/:slug/:edicion" element={<EdicionDetallePage />} />
        <Route path="/contacto" element={<ContactoPage />} />
        <Route path="/galeria" element={<GaleriasPage />} />
        <Route path="/galeria/:slug" element={<GaleriaDetallePage />} />
        <Route path="/noticias" element={<NoticiasPage />} />
        <Route path="/noticias/:slug" element={<NoticiaDetallePage />} />
        <Route path="/eventos" element={<EventosPage />} />
        <Route path="/eventos/:slug" element={<EventoDetallePage />} />
        <Route path="/accesibilidad" element={<AccesibilidadPage />} />
        <Route path="/politica-privacidad" element={<PaginaEstaticaPage />} />
        <Route path="/aviso-legal" element={<PaginaEstaticaPage />} />
        <Route path="/cookies" element={<PaginaEstaticaPage />} />
        <Route path="/paginas/:slug" element={<PaginaEstaticaPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
